import React, { useRef } from "react"
import useStore from "../../utils/useStore"

const TextComponent = React.memo(({ item, isFullScreen }) => {
    const dragging = useStore((state) => state.dragging)
    const setDragging = useStore((state) => state.setDragging)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)
    const resizing = useStore((state) => state.resizing)
    const setResizing = useStore((state) => state.setResizing)
    const editElements = useStore((state) => state.editElements)
    const selects = useStore((state) => state.selects)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const deleteElement = useStore((state) => state.deleteElement)

    const selected = selects?.find((e) => e === item?.id)
    const inputRef = useRef(null);

    const selectAllText = () => {
        if (inputRef.current !== document.activeElement) {
            const el = inputRef.current;
            if (!el) return;

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(el);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const onMouseDown = (event) => {
        window.getSelection().removeAllRanges()
        if (inputRef.current !== document.activeElement) {
            event.preventDefault()
        }
        if (selected) {
            //selects?.length > 1 || 
        } else if (event?.shiftKey) {
            addSelects(item?.id, true)
        } else {
            addSelects(item?.id)
        }
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preHeight", event?.target?.offsetHeight, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        setClickedPosition({ x: event.clientX, y: event.clientY })
        if (!selected) {
            setDragging(true)
        }
    }

    const onMouseHandleDown = (event) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("preWidth", item?.style?.width, item?.id)
        setResizing({ cursor: "ew-resize" })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    const onMouseUp = () => {
        if (resizing) {
            setResizing(false)
        } else if (!dragging) {
            setEditing(true)
        }
    }

    const onBlur = (event) => {
        const val = event?.currentTarget?.innerText
        if (!val?.trim()) {
            deleteElement(item?.id)
        } else if (val !== item?.val) {
            editElements("value", val, item?.id)
        }
    }

    const formatText = (val) => {
        if (item?.bullet) {
            return (
                `<ul>
                    ${val?.split('\n')?.map((itm) => `<li>${itm}</li>`).join('')}
                </ul>`
            )
        } else {
            return val?.replaceAll('\n', '<br/>')
        }
    }

    return (
        <div className={!isFullScreen && selected ? 'Presentation_Text_Select Presentation_Text_Selected' : 'Presentation_Text_Select'} style={{ position: "absolute", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, pointerEvents: isFullScreen ? "none" : "", cursor: resizing ? "ew-resize" : dragging ? "move" : selected ? "text" : "default", userSelect: "none" }} onMouseUp={onMouseUp} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
            if (editing) {
                selectAllText()
            }
        }}>
            <div ref={inputRef} className='Presentation_Text' contentEditable={!dragging} spellCheck={false} onBlur={onBlur} onKeyDown={(e) => e?.stopPropagation()} style={{ ...item?.style }} suppressContentEditableWarning dangerouslySetInnerHTML={{ __html: formatText(item?.value) }} />
            {selected && !dragging && !isFullScreen ?
                <div className='Presentation_Text_Handle' onMouseDown={onMouseHandleDown} />
                :
                null}
        </div>
    )
})

export default TextComponent;